import groq from 'groq'

import { frameBuilderImageFragment } from './image'

const frameBuilderProfileTextureFragment = groq`
  ...,
  gallery[] {
    ...,
    image {
      ${frameBuilderImageFragment}
    },
  },
`

const frameBuilderProductProfileTextureFragment = groq`
  _id,
  profile,
  texture,
  sku,
  price,
  discountPercent,
`

export const frameBuilderProfileTextureObjectFragment = groq`
  "profileTextures": *[
    _type == "frameBuilderProfileTexture" &&
    locale == $locale &&
    deactivate != true
  ] {
    ${frameBuilderProfileTextureFragment}
  },
`

export const frameBuilderProductProfileTextureObjectFragment = groq`
  "profileTextures": *[
    _type == "frameBuilderProfileTexture" &&
    locale == $locale &&
    deactivate != true
  ] {
    ${frameBuilderProductProfileTextureFragment}
  },
`
